
import { useFieldArray, Control } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Plus, Trash2 } from "lucide-react";

// Use a more flexible type for the form data
interface FlexibleFormData {
  [key: string]: any;
}

interface DynamicFieldArraySectionProps {
  name: string;
  control: Control<FlexibleFormData>;
  label: string;
  addButtonLabel: string;
  placeholder: string;
  rows?: number;
}

export function DynamicFieldArraySection({
  name,
  control,
  label,
  addButtonLabel,
  placeholder,
  rows = 2,
}: DynamicFieldArraySectionProps) {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Label>{label}</Label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => append("")}
        >
          <Plus className="h-4 w-4 mr-1" />
          {addButtonLabel}
        </Button>
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className="flex gap-2 mb-2">
          <Textarea
            {...control.register(`${name}.${index}`)}
            placeholder={placeholder}
            rows={rows}
          />
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => remove(index)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
      {fields.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No entries added yet. Click "{addButtonLabel}" to get started.
        </p>
      )}
    </div>
  );
}
